import { openChooseIPModal } from '$/components/ChooseIpModal/chooseIPStore';
import { useOfficialStore } from '$/store/useOfficialStore';

/** 首页项目卡共用登录校验与角色 IP 选择流程，保持列表态和空态行为一致。 */
export function useHomeProjectCreationAction() {
  const isUserLoggedIn = useOfficialStore((state) => state.isUserLoggedIn());
  const toLogin = useOfficialStore((state) => state.toLogin);

  /** 游客先登录，已登录用户进入新建项目的角色 IP 选择弹窗。 */
  const handleCreateProject = () => {
    if (!isUserLoggedIn) {
      toLogin().catch(() => {});
      return;
    }

    openChooseIPModal(undefined, '', 'home_create_project');
  };

  return handleCreateProject;
}
